module.exports = __webpack_public_path__ + "img/header-diamondJewelrySignature.8fd4a95.webp";